import { reduxKey } from '../constants';
import { createAction } from 'redux-actions';

// Dynamic redux
export const reduxModuleLoaded = createAction(
  `${reduxKey}.REDUX_READY`,
  () => ({})
);

export const updateMenus = createAction(`${reduxKey}.UPDATE_MENUS`, () => ({}));

export const openMuro = createAction(`${reduxKey}.OPEN_MURO`, props => ({
  props,
}));

export const closeMuro = createAction(`${reduxKey}.CLOSE_MURO`, () => ({}));
